module.exports = __webpack_public_path__ + "img/Hipercard.4704d2ea.svg";